/*----------------------
  DECISION PORTAL
  Customer color selection after receiving samples
 ----------------------*/
DecisionPortal = {
  // Translations for dynamic text (static text uses Shopify locale files)
  i18n: {
    es: {
      order_ref: 'Pedido',
      size: 'Medida',
      deadline_notice: 'Tienes hasta el {{date}} para elegir tu acabado',
      already_decided_msg: 'Ya has elegido el acabado para tu {{product}}: {{color}}',
      success_msg: 'Has elegido {{color}} para tu {{product}}. Te enviaremos un email de confirmación.',
      error_not_found: 'No hemos encontrado tu decisión. Comprueba el enlace o contacta con nosotros.',
      error_expired: 'El plazo para elegir ha vencido. Contacta con nosotros para más información.',
      error_generic: 'Ha ocurrido un error. Inténtalo de nuevo o contacta con nosotros.',
      confirming: 'CONFIRMANDO...',
    },
    en: {
      order_ref: 'Order',
      size: 'Size',
      deadline_notice: 'You have until {{date}} to choose your finish',
      already_decided_msg: 'You have already chosen the finish for your {{product}}: {{color}}',
      success_msg: 'You chose {{color}} for your {{product}}. We will send you a confirmation email.',
      error_not_found: 'We could not find your decision. Check the link or contact us.',
      error_expired: 'The deadline to choose has passed. Contact us for more information.',
      error_generic: 'An error occurred. Try again or contact us.',
      confirming: 'CONFIRMING...',
    },
    fr: {
      order_ref: 'Commande',
      size: 'Dimensions',
      deadline_notice: 'Vous avez jusqu\'au {{date}} pour choisir votre finition',
      already_decided_msg: 'Vous avez déjà choisi la finition pour votre {{product}} : {{color}}',
      success_msg: 'Vous avez choisi {{color}} pour votre {{product}}. Nous vous enverrons un email de confirmation.',
      error_not_found: 'Nous n\'avons pas trouvé votre décision. Vérifiez le lien ou contactez-nous.',
      error_expired: 'Le délai pour choisir est dépassé. Contactez-nous pour plus d\'informations.',
      error_generic: 'Une erreur s\'est produite. Réessayez ou contactez-nous.',
      confirming: 'CONFIRMATION...',
    },
    ca: {
      order_ref: 'Comanda',
      size: 'Mida',
      deadline_notice: 'Tens fins al {{date}} per escollir el teu acabat',
      already_decided_msg: 'Ja has escollit l\'acabat per al teu {{product}}: {{color}}',
      success_msg: 'Has escollit {{color}} per al teu {{product}}. T\'enviarem un email de confirmació.',
      error_not_found: 'No hem trobat la teva decisió. Comprova l\'enllaç o contacta amb nosaltres.',
      error_expired: 'El termini per escollir ha vençut. Contacta amb nosaltres per a més informació.',
      error_generic: 'S\'ha produït un error. Torna-ho a provar o contacta amb nosaltres.',
      confirming: 'CONFIRMANT...',
    },
  },

  locale: 'es',
  token: null,
  data: null,
  selectedSurface: null,
  selectedLeg: null,

  init: function () {
    var $portal = $(".decision-portal");
    if (!$portal.length) return;

    this.$portal = $portal;
    this.locale = $portal.data("locale") || "es";
    this.apiBase = $portal.data("api-base");

    // Get token from URL
    var params = new URLSearchParams(window.location.search);
    this.token = params.get("t");

    if (!this.token) {
      this.showError(this.t("error_not_found"));
      return;
    }

    this.fetchData();
  },

  t: function (key, replacements) {
    var str = (this.i18n[this.locale] || this.i18n.es)[key] || key;
    if (replacements) {
      for (var k in replacements) {
        str = str.replace("{{" + k + "}}", replacements[k]);
      }
    }
    return str;
  },

  fetchData: function () {
    var self = this;

    $.ajax({
      url: this.apiBase + "?t=" + encodeURIComponent(this.token),
      method: "GET",
      dataType: "json",
      success: function (data) {
        self.data = data;
        self.locale = data.locale || self.locale;
        self.render();
      },
      error: function (xhr) {
        if (xhr.status === 404) {
          self.showError(self.t("error_not_found"));
        } else {
          self.showError(self.t("error_generic"));
        }
      },
    });
  },

  render: function () {
    var data = this.data;

    // Already decided
    if (data.status === "decided") {
      var colorName = this.findColorName(data.chosenSurfaceColor, data.colorOptions);
      this.$portal.find(".decision-portal__decided-info").text(
        this.t("already_decided_msg", {
          product: data.productTitle || "",
          color: colorName,
        })
      );
      this.showState("decided");
      return;
    }

    // Expired without decision
    if (data.status === "expired") {
      this.showError(this.t("error_expired"));
      return;
    }

    // Awaiting delivery — show main anyway (they might have samples already)
    // Main decision view
    this.$portal.find(".decision-portal__product-title").text(data.productTitle || "");

    var orderInfo = "";
    if (data.orderName) orderInfo += this.t("order_ref") + " " + data.orderName;
    if (data.productSize) orderInfo += (orderInfo ? " · " : "") + this.t("size") + " " + data.productSize;
    this.$portal.find(".decision-portal__order-info").text(orderInfo);

    // Deadline
    if (data.decisionDeadline) {
      var deadline = new Date(data.decisionDeadline);
      var dateStr = deadline.toLocaleDateString(this.locale, {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
      var $deadline = this.$portal.find(".decision-portal__deadline");
      $deadline.find("p").text(this.t("deadline_notice", { date: dateStr }));
      $deadline.show();
    }

    // Render surface swatches
    this.renderSwatches(
      this.$portal.find('[data-group="surface"]'),
      data.colorOptions,
      "surface"
    );

    // Render leg swatches if dual-material
    if (data.legColorOptions && data.legColorOptions.length > 0) {
      this.renderSwatches(
        this.$portal.find('[data-group="legs"]'),
        data.legColorOptions,
        "legs"
      );
      this.$portal.find(".decision-portal__legs").show();
    }

    this.bindEvents();
    this.showState("main");
  },

  renderSwatches: function ($container, options, group) {
    $container.empty();

    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var $swatch = $('<button class="decision-portal__swatch" data-code="' + opt.code + '" data-group="' + group + '">');

      if (opt.swatch.indexOf("gradient:") === 0) {
        $swatch.append(
          '<div class="decision-portal__swatch-color" style="background:' + opt.swatch.replace("gradient:", "") + '"></div>'
        );
      } else if (opt.swatch.indexOf("#") === 0) {
        $swatch.append(
          '<div class="decision-portal__swatch-color" style="background:' + opt.swatch + '"></div>'
        );
      } else {
        $swatch.append(
          '<img class="decision-portal__swatch-img" src="' + opt.swatch + '" alt="' + opt.name + '" loading="lazy">'
        );
      }

      $swatch.append('<div class="decision-portal__swatch-name">' + opt.name + "</div>");
      $container.append($swatch);
    }
  },

  bindEvents: function () {
    var self = this;

    // Swatch selection
    this.$portal.on("click", ".decision-portal__swatch", function () {
      var $btn = $(this);
      var group = $btn.data("group");
      var code = $btn.data("code");

      // Deselect siblings
      $btn.siblings().removeClass("selected");
      $btn.addClass("selected");

      if (group === "surface") {
        self.selectedSurface = code;
      } else if (group === "legs") {
        self.selectedLeg = code;
      }

      self.updateConfirmButton();
    });

    // Confirm
    this.$portal.on("click", ".decision-portal__confirm-btn", function () {
      if ($(this).prop("disabled") || $(this).hasClass("loading")) return;
      self.submitDecision();
    });
  },

  updateConfirmButton: function () {
    var $btn = this.$portal.find(".decision-portal__confirm-btn");
    var needsLeg = this.data.legColorOptions && this.data.legColorOptions.length > 0;
    var ready = this.selectedSurface && (!needsLeg || this.selectedLeg);
    $btn.prop("disabled", !ready);
  },

  submitDecision: function () {
    var self = this;
    var $btn = this.$portal.find(".decision-portal__confirm-btn");
    var originalText = $btn.text();

    $btn.addClass("loading").text(this.t("confirming"));

    var payload = {
      token: this.token,
      surfaceColor: this.selectedSurface,
    };
    if (this.selectedLeg) {
      payload.legColor = this.selectedLeg;
    }

    $.ajax({
      url: this.apiBase + "/submit",
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify(payload),
      success: function () {
        var colorName = self.findColorName(self.selectedSurface, self.data.colorOptions);
        self.$portal.find(".decision-portal__success-msg").text(
          self.t("success_msg", {
            color: colorName,
            product: self.data.productTitle || "",
          })
        );
        self.showState("success");
      },
      error: function () {
        $btn.removeClass("loading").text(originalText);
        alert(self.t("error_generic"));
      },
    });
  },

  findColorName: function (code, options) {
    if (!code || !options) return code;
    for (var i = 0; i < options.length; i++) {
      if (options[i].code === code) return options[i].name;
    }
    return code;
  },

  showState: function (state) {
    this.$portal.find(".decision-portal__state").hide();
    this.$portal.find('[data-state="' + state + '"]').show();
  },

  showError: function (message) {
    this.$portal.find(".decision-portal__error-msg").text(message);
    this.showState("error");
  },
};

$(document).ready(function () {
  DecisionPortal.init();
});
$(document).on("shopify:section:load", function () {
  DecisionPortal.init();
});
